import { render, staticRenderFns } from "./LaboratoryRight.vue?vue&type=template&id=522c072c&scoped=true&"
import script from "./LaboratoryRight.vue?vue&type=script&lang=js&"
export * from "./LaboratoryRight.vue?vue&type=script&lang=js&"
import style0 from "./LaboratoryRight.vue?vue&type=style&index=0&id=522c072c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522c072c",
  null
  
)

export default component.exports